import { Info } from 'lucide-react';
import { Tooltip as TooltipPrimitive } from 'radix-ui';

interface InfoTooltipProps {
  /** What the tooltip says. Keep it to the one thing the label alone can't — a format, a default, an edge case. */
  content: string;
  label?: string;
}

/** A small info affordance for the one piece of context a field's label can't carry on its own — never a substitute for a clearer label. */
export function InfoTooltip({ content, label = 'More information' }: InfoTooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={200}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <button
            type="button"
            aria-label={label}
            className="inline-flex text-muted-foreground transition-colors duration-150 ease-out hover:text-foreground"
          >
            <Info className="size-3.5" aria-hidden />
          </button>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            sideOffset={6}
            className="z-50 max-w-xs rounded-md border border-border bg-popover px-3 py-1.5 text-xs text-popover-foreground shadow-md"
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-popover" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
